/**
 * Wrap a public storage URL with Cloudflare Image Transformations
 * (`cdn-cgi/image/...`) for resize + format negotiation.
 *
 * Skips the transformation when the URL goes through our auth-gated API
 * proxy (`/api/storage/object/...`) — those paths don't exist on the CDN
 * domain (`storage.deepguide.ai`) and would 404, and the proxy already
 * applies access control we'd lose by handing the URL to the CDN.
 */
export function getImageUrl(url: string, width: number = 1920, quality = 75) {
  if (!url) return url;
  if (url.includes('/api/storage/object/')) return url;
  return `https://storage.deepguide.ai/cdn-cgi/image/format=auto,quality=${quality},fit=scale-down,width=${width}/${url}`;
}
